import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, TrophyIcon, GraduationCapIcon, BadgeCheckIcon } from 'lucide-react';
const BOARD_SERVICE = [{
  Icon: UsersIcon,
  role: 'Board Member & Treasurer',
  org: 'Over 60s Club of Stamford (501c3)',
  note: 'Fiduciary oversight, financial stewardship, and nonprofit reporting for a registered charitable organization.'
}, {
  Icon: TrophyIcon,
  role: 'Board Member',
  org: "St. Patrick's Gaelic Football & Hurling Club",
  note: 'Governance, community programming, and organizational development for a volunteer-run sporting institution.'
}];
const CREDENTIALS = [{
  Icon: GraduationCapIcon,
  label: 'Education',
  primary: 'Bachelor of Business Studies (BBS Hons), Accounting & Finance',
  secondary: 'Dublin City University'
}, {
  Icon: BadgeCheckIcon,
  label: 'Credentials',
  primary: 'Active Certified Public Accountant (CPA)',
  secondary: 'New York State License #114833-1'
}];
export function Governance() {
  return <section aria-labelledby="governance-heading" className="w-full bg-white" data-id="element-150" data-mp="2ym77uqplzqg1">
      <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-151" data-mp="33j75cd8e7kvj">
        <h2 id="governance-heading" className="text-[11px] font-semibold uppercase tracking-widest text-navy-700" data-id="element-152" data-mp="2owdxtu547jdw">
          Board Service, Education &amp; Credentials
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-153" data-mp="2ftwafcdq4kpb">
          <div className="lg:col-span-7" data-id="element-154" data-mp="2kuk1tz5v73k2">
            <h3 className="font-serif text-2xl text-navy-900" data-id="element-155" data-mp="2kvbx18vjuz9t">
              Current Board &amp; Committee Service
            </h3>
            <ul className="mt-6 divide-y divide-slateink-300/70 border-y border-slateink-300/70" data-id="element-156" data-mp="2avuu2z7omzhj">
              {BOARD_SERVICE.map((item, i) => <motion.li key={item.org} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.08
            }} className="flex gap-5 py-7" data-id="element-157" data-mp="46oizh4evxl7" data-mpi={i}>
                  <span className="flex h-11 w-11 flex-none items-center justify-center border border-slateink-300 text-navy-900" data-id="element-158" data-mp="3tu96jxk8eyqq">
                    <item.Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-159" data-mp="3ptz2wrjwwkf1" />
                  </span>
                  <div data-id="element-160" data-mp="qchb296vzwns">
                    <p className="font-serif text-lg text-navy-900" data-id="element-161" data-mp="qfwnt5d38tm1">{item.role}</p>
                    <p className="mt-1 text-sm font-medium text-gold-600" data-id="element-162" data-mp="lf8x6ksruesc">{item.org}</p>
                    <p className="mt-3 text-sm leading-relaxed text-slateink-600" data-id="element-163" data-mp="gmo79uczklu3">
                      {item.note}
                    </p>
                  </div>
                </motion.li>)}
            </ul>
          </div>

          <div className="lg:col-span-5" data-id="element-164" data-mp="1964qjmcvli1p">
            <h3 className="font-serif text-2xl text-navy-900" data-id="element-165" data-mp="14cilaf91kgfx">Education &amp; Credentials</h3>
            <div className="mt-6 space-y-5" data-id="element-166" data-mp="2n13cbnuc375p">
              {CREDENTIALS.map((item, i) => <motion.div key={item.label} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.08
            }} className="border-l-2 border-gold-500 bg-slateink-100 p-7" data-id="element-167" data-mp="2rymngevqj3tf" data-mpi={i}>
                  <div className="flex items-center gap-3" data-id="element-168" data-mp="3axqtrfvw6jhe">
                    <item.Icon className="h-4 w-4 text-navy-900" strokeWidth={1.75} aria-hidden="true" data-id="element-169" data-mp="3aw5zlrdhp2k2" />
                    <span className="text-[11px] uppercase tracking-widest text-slateink-600" data-id="element-170" data-mp="3jpsqp46r5hmx">
                      {item.label}
                    </span>
                  </div>
                  <p className="mt-4 font-serif text-lg leading-snug text-navy-900" data-id="element-171" data-mp="3tpjobeqm0cr8">
                    {item.primary}
                  </p>
                  <p className="mt-2 text-sm text-slateink-600" data-id="element-172" data-mp="3fzor4iinjd7l">{item.secondary}</p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}